// @flow

import type { AppState } from './common/typings';

export const BUTTON_HEIGHT = '46px';
export const BIG_BUTTON_HEIGHT = 64;
export const FORM_ROW_HEIGHT = '38px;';
export const WORK_AREA_WIDTH = 480;
export const STORAGE_PREFIX = '@SlingKioskStorage:';
export const DATE_FORMAT = 'YYYY-MM-DD';
export const SHORT_DAY_NAME_FORMAT_US = 'MMM D';
export const SHORT_DAY_NAME_FORMAT_EU = 'D MMM';
export const TOAST_DISPLAY_TIME = 3000;
export const UNPAID_BREAKS = 1; // TODO: sdk
export const PAID_BREAKS = 2; // TODO: sdk
export const SMALL_DEVICE_WIDTH = 1000;
export const SMALL_DEVICE_HEIGHT = 900;
export const PIN_PAD_MINIMAL_HEIGHT = 524 + 32; //pinPad height + minimal padding from top and bottom combined

export const APP_STATE_CLOCKED_IN = 'clockedIn';
export const APP_STATE_INITIALIZING = 'initializing';
export const APP_STATE_CHOOSE_SHIFT = 'chooseShift';
export const APP_STATE_ON_BREAK = 'onBreak';
export const APP_STATE_END_BREAK = 'endBreak';
export const APP_STATE_CLOCKED_OUT = 'clockedOut';
export const APP_STATE_NOTHING_TO_DO = 'nothingToDo';

export const SUPPORTED_BUTTON_APP_STATES = [
  APP_STATE_CLOCKED_IN,
  APP_STATE_CLOCKED_OUT,
  APP_STATE_ON_BREAK,
  APP_STATE_END_BREAK
];

export const DESCRIPTION_FIELD_MAP: {
  [AppState]: string // this is not entirely true as only 4 options are supported but no better idea at this point
} = {
  [APP_STATE_CLOCKED_IN]: 'clockedInLocal',
  [APP_STATE_ON_BREAK]: 'startBreakInLocal',
  [APP_STATE_END_BREAK]: 'endBreakInLocal',
  [APP_STATE_CLOCKED_OUT]: 'clockOutInLocal'
};

export const BUTTON_THEME_BRAND = 'brand';
export const ANIMATION_DURATION = 300;
export const ANIMATION_DURATION_CSS = '0.3s';
export const PIN_PAD_ANIMATION_DURATION = 200;
export const PIN_PAD_ANIMATION_DURATION_CSS = '0.2s';

export const STORAGE_GUID_FIELD = 'guid';
export const STORAGE_TIME_FORMAT_FIELD = 'usTimeFormat';
export const STORAGE_SESSION_FIELD = 'kioskSessionId';

export const ENTER_KEY_CODE = 13;
export const BACKSPACE_KEY_CODE = 8;
